export let VIDEO_TYPES;
(function (VIDEO_TYPES) {
  VIDEO_TYPES["MOVIE_THEATRICAL"] = "movie-theatrical";
  VIDEO_TYPES["TELEVISION"] = "television";
  VIDEO_TYPES["MADE_FOR_VIDEO"] = "made-for-video";
  VIDEO_TYPES["VIDEO_COURSE"] = "video-course";
  VIDEO_TYPES["PORTFOLIO"] = "portfolio";
  VIDEO_TYPES["PERSONAL"] = "personal";
  VIDEO_TYPES["FILM"] = "film";
  VIDEO_TYPES["VLOG"] = "vlog";
  VIDEO_TYPES["WEB_SERIES"] = "web-series";
  VIDEO_TYPES["PRODUCT_DEMO"] = "product-demo";
  VIDEO_TYPES["TESTIMONIALS"] = "testimonials";
  VIDEO_TYPES["TUTORIALS"] = "tutorials";
  VIDEO_TYPES["EDUCATION"] = "education";
  VIDEO_TYPES["MUSIC"] = "music";
  VIDEO_TYPES["OTHER"] = "other";
})(VIDEO_TYPES || (VIDEO_TYPES = {}));
export const VIDEO_TYPES_LIST = [VIDEO_TYPES.MOVIE_THEATRICAL, VIDEO_TYPES.TELEVISION, VIDEO_TYPES.MADE_FOR_VIDEO, VIDEO_TYPES.VIDEO_COURSE, VIDEO_TYPES.PORTFOLIO, VIDEO_TYPES.PERSONAL, VIDEO_TYPES.FILM, VIDEO_TYPES.VLOG, VIDEO_TYPES.WEB_SERIES, VIDEO_TYPES.PRODUCT_DEMO, VIDEO_TYPES.TESTIMONIALS, VIDEO_TYPES.TUTORIALS, VIDEO_TYPES.EDUCATION, VIDEO_TYPES.MUSIC, VIDEO_TYPES.OTHER];
//# sourceMappingURL=video-types.js.map